const scrollToNext = (carouselRefCurrent: HTMLDivElement, itemsOffset: Map<string, number>) => {
  if (!carouselRefCurrent) {
    return;
  }

  const iterator = itemsOffset?.entries();
  let currentEntry = iterator?.next();

  const threshold = carouselRefCurrent.scrollLeft + carouselRefCurrent.offsetWidth;

  // Find the item that is the closest to the right of the visible area and scroll to it.
  while (!currentEntry?.done) {
    const [, value] = currentEntry?.value;
    const nextEntry = iterator?.next();

    if (value <= threshold && (nextEntry?.done || nextEntry?.value?.[1] > threshold)) {
      carouselRefCurrent.scrollTo({
        left: value,
        behavior: 'smooth',
      });
      return;
    }
    currentEntry = nextEntry;
  }
};

export default scrollToNext;
